$mol_view_tree2_to_js_test_ex_bidi_indexed_foo $mol_object
	indexed*? <=> owner*? null
